import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import { ResourceCollection } from "@/modules/api/resource.collection";

import { getCalendarDateKey } from "./calendar-date.helper";
import ProductGroup from "./product-group.model";

export default class ProductGroupRepository extends BasicRepository<ProductGroup> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<ProductGroup>,
    responseParser: ApiCollectionResponseParserService<ProductGroup>
  ) {
    super("holiday_period_product_groups", api, objectBuilder, responseParser);
  }

  public getByPeriodId(
    periodId: string
  ): Promise<ResourceCollection<ProductGroup>> {
    return this.fetchList({ period: periodId }, 1, 9999, undefined, false);
  }

  public async updateForPeriod(
    periodId: string,
    items: ProductGroup[]
  ): Promise<ProductGroup[]> {
    const response = await this.api.post(
      `${this.resourceName}/update_requests`,
      {
        period: Number(periodId),
        items: items.map((item) => this.prepareData(item)),
      }
    );
    return this.responseParser
      .parse(response.data, this.objectBuilder)
      .getItems();
  }

  protected prepareData(
    item: ProductGroup
  ): Record<string, string | number | number[]> {
    if (!item.internationalDueDate || !item.domesticDueDate) {
      throw new Error("Every Holiday group needs valid dates.");
    }

    return {
      ...(item.isNew ? {} : { id: item.id }),
      name: item.name,
      internationalDueDate: getCalendarDateKey(item.internationalDueDate),
      domesticDueDate: getCalendarDateKey(item.domesticDueDate),
      products: item.products.map(Number),
    };
  }
}
